"use client";

import Link from "next/link";

import { FormButton } from "@/components/form/FormButton";
import { twMerge } from "@/utils/twMerge";

import type { ComponentProps, ReactNode } from "react";

export function NotificationActions({ children }: { children: ReactNode }) {
  // relative lifts the actions above NotificationRow's clickable-background link
  return <div className="relative mt-2.5 mb-px grid grid-cols-2 gap-2">{children}</div>;
}

export function NotificationAcceptButton({
  className,
  ...rest
}: ComponentProps<typeof FormButton>) {
  return (
    <FormButton
      variant="accent"
      size="sm"
      className={twMerge(
        "h-8.5 border border-white text-[14px] leading-none font-medium tracking-[-0.02em] dark:border-gray-900",
        className,
      )}
      {...rest}
    />
  );
}

export function NotificationDeclineButton({
  className,
  ...rest
}: ComponentProps<typeof FormButton>) {
  return (
    <FormButton
      variant="secondary"
      size="sm"
      className={twMerge(
        "h-8.5 border border-gray-300 bg-white text-[14px] leading-none font-medium tracking-[-0.02em] text-black shadow-none dark:border-gray-700 dark:bg-transparent dark:text-white",
        className,
      )}
      {...rest}
    />
  );
}

export function NotificationLinkButton({ className, ...rest }: ComponentProps<typeof Link>) {
  return (
    <Link
      className={twMerge(
        "flex h-8.5 items-center justify-center rounded-8 border border-white bg-blue-100 px-4 text-[14px] leading-none font-medium tracking-[-0.02em] text-blue-500 hover:bg-blue-200 dark:border-gray-900 dark:bg-blue-900 dark:text-blue-200 dark:hover:bg-blue-800",
        className,
      )}
      {...rest}
    />
  );
}
